//StreamIQ keys

export const bootstrapsKeyword = 'StreamIQ config'

// Toya keys
export const idTokenKeyword = 'idToken'
export const appConfigKeyword = 'dottv:config'

//common keys
export const sessionTokenLsKeyword = 'sessionToken'
export const refreshTokenKeyword = 'refreshToken'
export const lastTimeStart = 'lastTimeStart'

export const getFromLocalStorage = (keyword: string) => {
    const stringifiedConfig = localStorage.getItem(keyword)
    return stringifiedConfig
}
export const saveToLocalStorage = (keyword: string, value: string) => {
    if (value) {
        localStorage.setItem(keyword, value)
    }
}

export const removeFromLocalStorage = (keyword: string) => {
    localStorage.removeItem(keyword)
}
